import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

function ModalEditProfileName({ show, onHide, submit, data = { id: null, val: null } }) {
  const [disable, setDisable] = useState(false);
  const [name, setName] = useState();
  function handleOnHide() {
    onHide();
  }
  function handleSubmit(val) {
    setName();
    submit({ id: data.id, val: val });
  }
  function hanldeChangeName(val) {
    setName(val);
  }

  useEffect(() => {
    setDisable(name ? false : true);
  }, [name]);
  return (
    <>
      <Modal show={show} onHide={() => handleOnHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Edit user name</h5>
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input onChange={(e) => hanldeChangeName(e.target.value)} defaultValue={data.val} type="text" className="form-control" />
          </div>
        </ModalBody>
        <ModalFooter>
          <button onClick={() => handleSubmit(name)} disabled={disable} type="button" className="btn btn-outline-theme">
            Save changes
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default ModalEditProfileName;
